import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled, { css } from "styled-components";
import { RootState } from "../store";
import Part1DataChart from "./Part1DataChart";
import { useShallowEqualSelector } from "../modules/hooks"
import globalValues from "../store/globalValues";

//region style


const Container = styled.div`
  
  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      `;
    }
    else {
      return css`
        width: 100%;
      `;
    }
  }}

`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom:30px;
`;

const Part1BackGround = styled.div`
  width: 100%;
  background: #cae7e2;
  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      padding: 16px 10px 16px 10px;
      border-radius: 10px;
      `;
    }
    else {
      return css`
      border-radius: 30px;
      height: 900px;
      `;
    }
  }}

`;

const NameStatisticsInfo = styled.div`
  width: 1070px;
  height: 500px;
  display: flex;
  margin: 0 auto 65px auto;
`;

const Top10LastName = styled.div`
  width: 660px;
  height: 500px;
  border-right: 1px solid darkgray;
  margin-top: 30px;
  padding-right:30px;
`;

const Top10LastNameP = styled.p`
  font-size: 36px;
  font-weight: bold;
  color: #106b64;
  line-height: 0;


  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      margin-bottom: 40px;
      text-align: center;
      `;
    }
    else {
      return css`
      margin-bottom: 60px;
      `;
    }
  }}
`;

const MostCommonNameAndWord = styled.div`
  margin: 30px 0px 30px 40px;
  text-align: center;
  `;

const MostCommonName = styled.div`
`;

const MostCommonNameP = styled.p`
  font-size: 24px;
  font-weight: bold;
  color: #106b64;
  line-height: 14px;
  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      margin-top: 30px;
      margin-bottom: 30px;
      text-align: center;
      `;
    }

  }}
`;

const MostCommonWord = styled.div`
  margin-left: 40px;
`;

const MostCommonWordP = styled.p`
  font-size: 24px;
  font-weight: bold;
  color: #106b64;
  line-height: 14px;

  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      margin-top: 20px;
      margin-bottom: 30px;
      text-align: center;
      `;
    }

  }}

`;

const PersonIconDiv = styled.div`
  display: flex;
  padding-bottom: 25px;
`;

const PersonIconDiv2 = styled.div`
  display: flex;
  
  

  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      `;
    }
    else {
      return css`
      border-bottom: 1px solid darkgray;
      padding-bottom: 25px;
      `;
    }
  }}
`;

const HiddenDiv = styled.div`

${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
    right: -50px;
    top: -125px;
    `;
    }
    else {
      return css`
    left: -50px;
    top: -125px;
    `;
    }
  }}

position: absolute;


background-color: black;
color: white;
z-index: 2;
transition: visibility 0s, opacity 0.3s linear;
opacity: 0;
visibility:hidden;
`;

const MostCommonPersonTop1Icon = styled.div`
  background-image: url("${process.env.PUBLIC_URL}/images/01-yellow-person.png");
  width: 66px;
  height: 79px;
  background-size: 100%;
  background-repeat: no-repeat;
  margin: 0 4px;
  font-weight: bold;
  color: #1a979d;
  font-size: 15px;
  line-height: 14px;
  position: relative;
  ${(props) => {
    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      text-align: center;
      margin: 0 0.5vw;
      `;
    }
  }}

  &:hover > ${HiddenDiv} {
    visibility: visible;
    opacity: 0.8;
    height: 118px;
    width: 170px;
  }
  `;

const MostCommonPersonIcon = styled.div`
  background-image: url("${process.env.PUBLIC_URL}/images/01-green-person.png");
  width: 66px;
  height: 79px;
  background-size: 100%;
  background-repeat: no-repeat;
  margin: 0 4px;
  font-weight: bold;
  color: white;
  font-size: 15px;
  line-height: 14px;
  position: relative;
  
  ${(props) => {
    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      text-align: center;
      margin: 0 0.5vw;
      `;
    }
  }}

  &:hover > ${HiddenDiv} {
    visibility: visible;
    opacity: 0.8;
    height: 118px;
    width: 170px;
  }
  `;

const CommonName = styled.p`
  margin: 17px 0 22px 0;
  ${(props) => {
    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      margin: 24% 0 28% 0;
      `;
    }
  }}
 `;

const CommonNameRank = styled.p`
  font-weight: normal;
  line-height: 28px;
  font-size: 22px;
  margin: 5px 0;
 `;

const HiddenDivName = styled.div`
  display: flex;
  line-height: normal;
  font-size: 18px;
  margin: 16px 0 10px 16px;
  `;

const HiddenDivInfo = styled.div`
  display: flex;
  padding: 0 16px;
  font-family: Arial,Helvetica Neue,Helvetica,sans-serif;
  `;

const HiddenDivText = styled.div`
  line-height: normal;
  font-size: 14px;
  opacity: 0.9;
  `;

const HiddenDivShowTimes = styled.div`
  width:100px;
  text-align:start;
  `;

const HiddenDivNumber = styled.div`
  text-align: start;
  line-height: normal;
  font-size: 30px;
  font-weight: bold;
  letter-spacing: 3px;
  margin-top: 4px;
  `;

const HiddenDivRank = styled.div`
  padding-left: 5px;
  border-left: 1px dashed white;
  `;

  const Bubble = styled.div`
  position: relative;
  &:hover > ${HiddenDiv} {
    visibility: visible;
    opacity: 0.8;
    height: 118px;
    width: 170px;
  }
`;
  const BubbleDiv = styled.div`
    display: flex;
    padding-top: 50px;
    font-weight: bold;
  `;

const Bubble1 = styled.div`{
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: #0a7075;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 42px;
    `;

const Bubble2 = styled.div`{
      width: 85px;
      height: 85px;
      border-radius: 50%;
      background-color: #1b969e;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      font-size: 37px;  
      `;


const Bubble3 = styled.div`{
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #13aab3;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 28px;
  transform: translate(-63px, 143px);
  position: relative;
  &:hover > ${HiddenDiv} {
    visibility: visible;
    opacity: 0.8;
    height: 118px;
    width: 170px;
  }

  `;

const Bubble4 = styled.div`{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #2db9ca;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 24px;
    position: relative;
    &:hover > ${HiddenDiv} {
      visibility: visible;
      opacity: 0.8;
      height: 118px;
      width: 170px;
    }
  
    `;

const Bubble5 = styled.div`{
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #46becf;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 17px;
  position: relative;
  &:hover > ${HiddenDiv} {
    visibility: visible;
    opacity: 0.8;
    height: 118px;
    width: 170px;
  }

  `;

const NameStatisticsBabyInfo = styled.div`{
  display:flex;
  justify-content: center;
  align-items: center;
  margin: 30px auto;
  width: 1060px;
  height: 292px;
  background: white;
  border-radius: 10px;
  display: flex;
  align-items: center;
  `;

const BabyBigLogoOuter = styled.div`{
    margin-right: 40px;
`;

const BabyBigLogo = styled.div`{
  background: url("${process.env.PUBLIC_URL}/images/01-baby-lightColor.png") no-repeat;

  background-size: cover;

  ${(props) => {
    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      background-position: center center;
      background-size: 220px 346px;
      height: 346px;
      width: 100%;
      margin-top:10px;
      margin-bottom:30px;
        display: none;
      `;
    }
    else{
      return css`
      background-position-y: 60px;
      width: 220px;
      height: 346px;
      `;
    }
  }}

  `;

  const NewBornBabyP = styled.p`
  font-size: 36px;
  font-weight: bold;
  color: #106b64;
  line-height: 0;
  padding-top: 30px;
  text-align: center;
`;


const BabyMostCommonNameDiv = styled.div`{
  height: 250px;
  text-align: center;
  margin-left: 30px;
  padding-right: 30px;
  `;

const BabyMostCommonNameP = styled.p`{
    font-size: 24px;
    font-weight: bold;
    color: #106b64;
    margin-block-start: 12px;
    margin-block-end: 18px;

    ${(props) => {
      if (props.theme.isMobile || props.theme.isTablet) {
        return css`
        text-align: center;
        `;
      }
      
    }}
    `;

const BabyIconLayer1 = styled.div`{
      display: flex;
      padding-bottom: 12px;
`;

const BabyIconLayer2 = styled.div`{
  display: flex;
  `;

const YellowBabyIcon = styled.div`{
  background-image: url("${process.env.PUBLIC_URL}/images/01-baby-yellow.png");
  width: 60px;
  height: 94px;
  background-size: 100%;
  background-repeat: no-repeat;
  margin: 0 4px;
  font-weight: bold;
  color: #1a979d;
  font-size: 15px;
  line-height: 110px;
  position : relative;

  ${(props) => {
    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      text-align: center;
      `;
    }
  }}

  &:hover > ${HiddenDiv} {
    visibility: visible;
    opacity: 0.8;
    height: 118px;
    width: 170px;
  }

`;

const GreenBabyIcon = styled.div`{
  background-image: url("${process.env.PUBLIC_URL}/images/01-baby-green.png");
  width: 60px;
  height: 94px;
  background-size: 100%;
  background-repeat: no-repeat;
  margin: 0 4px;
  font-weight: bold;
  color: white;
  font-size: 15px;
  line-height: 110px;
  position : relative;

  ${(props) => {
    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      text-align: center;
      `;
    }
  }}

  &:hover > ${HiddenDiv} {
    visibility: visible;
    opacity: 0.8;
    height: 118px;
    width: 170px;
  }

`;

const BabyMostCommonNameWordP = styled.p`{
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #106b64;
  margin-block-start: 12px;

  ${(props) => {
    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      margin-top: 30px;
      `;
    }
  }}
`;

const BabyMostCommonNameWordDiv = styled.div`{
  margin-left: 20px;
  height: 250px;
  `;

const YellowBabyName = styled.p`
  margin: 20px 0 0 0;
  ${(props) => {
    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        margin: 12px 0 0 0;
      `;
    }
  }}
 `;

//endregion

function Part1(props: any) {
  const isMobile: any = useSelector((state: RootState) => state.storeSlice.isMobile);
  const isTablet: any = useSelector((state: RootState) => state.storeSlice.isTablet);
  const generalInfo: any = useShallowEqualSelector((state: RootState) => state.storeSlice.generalInfo);
  const [topName_Names, setTopName_Names] = useState([]);
  const [topName_Counts, setTopName_Counts] = useState([]);

  const [topNameWord_Words, setTopNameWord_Words] = useState([]);
  const [topNameWord_Counts, setTopNameWord_Counts] = useState([]);

  //const [topNewBornName_Names, setTopNewBornName_Names] = useState([]);
  //const [topNewBornName_Counts, setTopNewBornName_Counts] = useState([]);

  const [topNewBornNameWord_Words, setTopNewBornNameWord_Words] = useState([]);
  const [topNewBornNameWord_Counts, setTopNewBornNameWord_Counts] = useState([]);

  function changePosition(e: React.MouseEvent<HTMLDivElement, MouseEvent>, childrenPosition: any) {
    let hiddenDiv = e.currentTarget.children[childrenPosition] as HTMLDivElement;
    if (e.clientX <= 150) {
      hiddenDiv.style.left = "50px";
    }
  }

  function changePositionB(e: React.MouseEvent<HTMLDivElement, MouseEvent>, childrenPosition: any,x: any,y: any) {
    let hiddenDiv = e.currentTarget.children[childrenPosition] as HTMLDivElement;
    if (e.clientX <= 150) {
      hiddenDiv.style.left = x+"px";
      hiddenDiv.style.top = y+"px";
    }
    else{
      hiddenDiv.style.left = x+"px";
      hiddenDiv.style.top = y+"px";
    }
  }


  const GenHiddenDiv = (props: any) => {

    const word = props.Word;
    const count = props.Count;
    const rank = props.Rank;

    return (
      <HiddenDiv key={0}>
        <HiddenDivName>{word}</HiddenDivName>
        <HiddenDivInfo>
          <HiddenDivShowTimes>
            <HiddenDivText>出現次數</HiddenDivText>
            <HiddenDivNumber>{count}</HiddenDivNumber>
          </HiddenDivShowTimes>
          <HiddenDivRank>
            <HiddenDivText>排名</HiddenDivText>
            <HiddenDivNumber>{rank}</HiddenDivNumber>
          </HiddenDivRank>
        </HiddenDivInfo>
      </HiddenDiv>
    );
  }

  const LoopMostCommonName = () => {
    let ResultPartA = [];
    let ResultPartB = [];

    for (let i = 0; i < 5; i++) {
      if (i === 0) {
        ResultPartA.push(
          <MostCommonPersonTop1Icon key={i} onMouseOver={(e) => changePosition(e, 2)}>
            <CommonName>{topName_Names[i]}</CommonName>
            <CommonNameRank>{i + 1}</CommonNameRank>
            <GenHiddenDiv Word={topName_Names[i]} Count={topName_Counts[i]} Rank={i + 1} />
          </MostCommonPersonTop1Icon>
        )
      }
      else {
        ResultPartA.push(
          <MostCommonPersonIcon key={i} onMouseOver={(e) => changePosition(e, 2)}>
            <CommonName>{topName_Names[i]}</CommonName>
            <CommonNameRank>{i + 1}</CommonNameRank>
            <GenHiddenDiv Word={topName_Names[i]} Count={topName_Counts[i]} Rank={i + 1} />
          </MostCommonPersonIcon>
        )
      }
    }

    for (let i = 5; i < 10; i++) {
      ResultPartB.push(
        <MostCommonPersonIcon key={i} onMouseOver={(e) => changePosition(e, 2)}>
          <CommonName>{topName_Names[i]}</CommonName>
          <CommonNameRank>{i + 1}</CommonNameRank>
          <GenHiddenDiv Word={topName_Names[i]} Count={topName_Counts[i]} Rank={i + 1} />
        </MostCommonPersonIcon>
      )
    }

    let LoopMostCommonNameContainer = styled.div`
    ${(props) => {

      if (props.theme.isMobile || props.theme.isTablet) {
        return css`
        `;
      }
      else {
        return css`
          width: 100%;
        `;
      }
    }}
    `

    return (
      <LoopMostCommonNameContainer key={0}>
        <PersonIconDiv>
          {ResultPartA}
        </PersonIconDiv>
        <PersonIconDiv2>
          {ResultPartB}
        </PersonIconDiv2>
      </LoopMostCommonNameContainer>
    )
  }

  const LoopBabyIcon = () => {
    let ResultPartA = [];
    let ResultPartB = [];

    for (let i = 0; i < 5; i++) {

      if (i === 0) {
        ResultPartA.push(
          <YellowBabyIcon key={i} onMouseOver={(e) => changePosition(e, 1)}>
            <YellowBabyName>{topNewBornNameWord_Words[i]}</YellowBabyName>
            <GenHiddenDiv Word={topNewBornNameWord_Words[i]} Count={topNewBornNameWord_Counts[i]} Rank={i + 1} />
          </YellowBabyIcon>
        )
      }
      else {
        ResultPartA.push(
          <GreenBabyIcon key={i} onMouseOver={(e) => changePosition(e, 1)}>
            <YellowBabyName>{topNewBornNameWord_Words[i]}</YellowBabyName>
            <GenHiddenDiv Word={topNewBornNameWord_Words[i]} Count={topNewBornNameWord_Counts[i]} Rank={i + 1} />
          </GreenBabyIcon>
        )
      }
    }

    for (let i = 5; i < 10; i++) {
      ResultPartB.push(
        <GreenBabyIcon key={i} onMouseOver={(e) => changePosition(e, 1)}>
          <YellowBabyName>{topNewBornNameWord_Words[i]}</YellowBabyName>
          <GenHiddenDiv Word={topNewBornNameWord_Words[i]} Count={topNewBornNameWord_Counts[i]} Rank={i + 1} />
        </GreenBabyIcon>
      )
    }

    return (
      <Container key={0}>
        <BabyIconLayer1>
          {ResultPartA}
        </BabyIconLayer1>
        <BabyIconLayer2>
          {ResultPartB}
        </BabyIconLayer2>
      </Container>
    )
  }

  const LoopBubble = (props: any) => {
    const word = props.Word;
    const count = props.Count;

    useEffect(() => {
    }, [props])

    return (
      <BubbleDiv key={0}>
        <Bubble onMouseOver={(e) => changePositionB(e, 1 , 70 , -90)}>
          <Bubble1 >
            <div>{word[0]}</div>
          </Bubble1>
          <GenHiddenDiv Word={word[0]} Count={count[0]} Rank={1} />
        </Bubble>
        <Bubble onMouseOver={(e) => changePositionB(e, 1 , 50 , -138)}>
          <Bubble2 >
            <div>{word[1]}</div>
          </Bubble2>
          <GenHiddenDiv Word={word[1]} Count={count[1]} Rank={2} />
        </Bubble>
        <Bubble onMouseOver={(e) => changePositionB(e, 1 , -215 , -57)}>
          <Bubble3 >
          <div>{word[2]}</div>
          </Bubble3>
          <GenHiddenDiv Word={word[2]} Count={count[2]} Rank={3} />
        </Bubble>
        <Bubble onMouseOver={(e) => changePositionB(e, 1 , -220, -90)}>
          <Bubble4 >
          <div>{word[3]}</div>
          </Bubble4>
          <GenHiddenDiv Word={word[3]} Count={count[3]} Rank={4} />
        </Bubble>
        <Bubble onMouseOver={(e) => changePositionB(e, 1 , -215 , -75)}>
          <Bubble5 >
          <div>{word[4]}</div>
          </Bubble5>
          <GenHiddenDiv Word={word[4]} Count={count[4]} Rank={5} />
        </Bubble>

      </BubbleDiv>
    )

  }

  const AddAnimeion = () => {

    const Bubble01 = document.getElementsByClassName(Bubble1.styledComponentId)[0];
    const Bubble02 = document.getElementsByClassName(Bubble2.styledComponentId)[0];
    const Bubble03 = document.getElementsByClassName(Bubble3.styledComponentId)[0];
    const Bubble04 = document.getElementsByClassName(Bubble4.styledComponentId)[0];
    const Bubble05 = document.getElementsByClassName(Bubble5.styledComponentId)[0];
    Bubble01.classList.add("FlowAnimation1");
    Bubble02.classList.add("FlowAnimation2");
    Bubble03.classList.add("FlowAnimation3");
    Bubble04.classList.add("FlowAnimation4");
    Bubble05.classList.add("FlowAnimation5");

  }

  useEffect(() => {
    if (generalInfo) {
      setTopName_Names(generalInfo.topName.map((m: any) => m.name));
      setTopName_Counts(generalInfo.topName.map((m: any) => m.count));
      setTopNameWord_Words(generalInfo.topNameWord.map((m: any) => m.name));
      setTopNameWord_Counts(generalInfo.topNameWord.map((m: any) => m.count));
      //setTopNewBornName_Names(generalInfo.topNewBornName.map((m: any) => m.name));
      //setTopNewBornName_Counts(generalInfo.topNewBornName.map((m: any) => m.count));
      setTopNewBornNameWord_Words(generalInfo.topNewBornNameWord.map((m: any) => m.name));
      setTopNewBornNameWord_Counts(generalInfo.topNewBornNameWord.map((m: any) => m.count));

      setTimeout(() => {
        const BubbleContainer1 = document.getElementById("BubbleContainer1") as HTMLDivElement | null;
        const BubbleContainer2 = document.getElementById("BubbleContainer2") as HTMLDivElement | null;
        BubbleContainer1?.classList.remove("HiddenBubbles");
        BubbleContainer1?.classList.add("ShowBubbles");
        BubbleContainer2?.classList.remove("HiddenBubbles");
        BubbleContainer2?.classList.add("ShowBubbles");
        AddAnimeion();
      }, 50);
    }
  }, [generalInfo]);


  if (isMobile || isTablet) {
    return (
      <>
        <Part1BackGround>
          <Top10LastNameP>澳門10大姓氏統計</Top10LastNameP>
          <Part1DataChart />
          <MostCommonNameP>全澳最常用名字</MostCommonNameP>
          <FlexContainer>
            <LoopMostCommonName />
          </FlexContainer>
          <MostCommonWordP>全澳最常用名字單字</MostCommonWordP>
          <FlexContainer>
            <MostCommonWord id="BubbleContainer1" className="HiddenBubbles">
              <LoopBubble Word={topNameWord_Words} Count={topNameWord_Counts} />
            </MostCommonWord>
          </FlexContainer>
        </Part1BackGround>

        <NewBornBabyP>新生嬰兒名字統計</NewBornBabyP>
        <BabyBigLogo />
        <Part1BackGround>
        <BabyMostCommonNameP>{globalValues.maxYear}年新生嬰兒最常見名字單字</BabyMostCommonNameP>
        <FlexContainer>
          <LoopBabyIcon/>
        </FlexContainer>
        {/*<BabyMostCommonNameWordP>20/23年新生嬰兒最常見名字單字</BabyMostCommonNameWordP>*/}
        {/*<FlexContainer>*/}
        {/*  <MostCommonWord id="BubbleContainer2" className="HiddenBubbles">*/}
        {/*    <LoopBubble Word={topNewBornNameWord_Words} Count={topNewBornNameWord_Counts} />*/}
        {/*  </MostCommonWord>*/}
        {/*</FlexContainer>*/}
        </Part1BackGround>

      </>
    )
  }
  else {
    return (
      <Part1BackGround>
        <NameStatisticsInfo>

          <Top10LastName>
            <Top10LastNameP>澳門10大姓氏統計</Top10LastNameP>
            <Part1DataChart />
          </Top10LastName>

          <MostCommonNameAndWord>
            <MostCommonNameP>全澳最常用名字</MostCommonNameP>
            <MostCommonName>
              <LoopMostCommonName />
            </MostCommonName>

            <MostCommonWordP>全澳最常用名字單字</MostCommonWordP>
            <MostCommonWord id="BubbleContainer1" className="HiddenBubbles">
              <LoopBubble Word={topNameWord_Words} Count={topNameWord_Counts} />
            </MostCommonWord>

          </MostCommonNameAndWord>

        </NameStatisticsInfo>
        <NameStatisticsBabyInfo>

          <BabyBigLogoOuter>
            <BabyBigLogo />
          </BabyBigLogoOuter>

          <BabyMostCommonNameDiv>
            <BabyMostCommonNameP>{globalValues.maxYear}年新生嬰兒最常見名字單字</BabyMostCommonNameP>
            <LoopBabyIcon />
          </BabyMostCommonNameDiv>

        </NameStatisticsBabyInfo>
      </Part1BackGround>
    )
  }
}

export default Part1;
